/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamPauseReason } from './oralExamPauseReason';

/**
 * Body for lecturer-initiated pause.
 */
export interface OralExamPauseRequest {
  reason?: OralExamPauseReason;
}
